import _ from 'underscore';
import { trim } from 'underscore.string';
import { queryify } from '@bingads-webui/url-util';
import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import { getProductScopeData, mergeData } from '@bingads-webui-campaign-react/product-services';
import { withDFMCache, getDFMCache, setDFMCache } from '@bingads-webui/dfm-cache';

export const getProductData = (cid, aid, uid) => {
  const url = queryify('/Campaign/NewCampaign/GetProductScope', {
    aid,
    cid,
    uid,
  });

  const params = {
    url,
    adapter: 'legacy',
    bypassCache: false,
    cacheResponse: true,
  };

  return createAsyncToken(jsData.Product.find('MetaData', params))
    // .chain((...args) => new Promise((resolve) => {
    //   setTimeout(() => resolve(...args), 5000);
    // }))
    // .chain((...args) => new Promise((resolve, reject) => {
    //   setTimeout(() => reject(new Error('Failed loading stores', ...args)), 5000);
    // }))
    .chain((data) => {
      // Filtering out Co-Op Store
      // eslint-disable-next-line no-param-reassign
      data.ProductCollectionAccounts =
        _.filter(data.ProductCollectionAccounts, store => !store.IsCoOpStore && !store.IsGlobalStore);

      return data;
    });
};

export const getProductScopeFromOData = (serverContext) => {
  const options = {
    dataName: 'MetaData',
    bypassCache: false,
    cacheResponse: true,
    getSalesCountryCollection: true,
  };

  const p$GetProductData = () => getProductScopeData(null, serverContext, options);
  const cacheKey = 'getPmaxProductScopeDFM';
  const getProductDataWithCache = withDFMCache(p$GetProductData, cacheKey, {}, false);

  return createAsyncToken(getProductDataWithCache())
  .chain((data) => {
    if (!getDFMCache(cacheKey)) {
      setDFMCache(cacheKey, new Promise((resolve) => { resolve(data); }));
    }

    // Filtering out Co-Op Store
    const mergedData = mergeData(data);

    mergedData.ProductCollectionAccounts = _.filter(mergedData.ProductCollectionAccounts, store => !store.IsCoOpStore && !store.IsGlobalStore);

    return mergedData;
  });
};

const parseStoreName = (storeText) => {
  const nameComponentIndex = storeText.indexOf(',');
  const nameComponent = storeText.substring(nameComponentIndex + 1);
  const nameIndex = nameComponent.indexOf(':');
  const name = trim(nameComponent.substring(nameIndex + 1));
  return name;
};

export const getStoreFromProductCollectionAccount = productCollectionAccount => ({
  id: productCollectionAccount.Value,
  text: productCollectionAccount.Text,
  name: parseStoreName(productCollectionAccount.Text),
});

export const getCountryFromSalesCountryCollection = legacyI18n => salesCountry => ({
  id: salesCountry.Value,
  text: legacyI18n.getString(`UserCountry_${salesCountry.Value}`),
});

export const getStores = ({ productData }) => {
  const stores = (productData && productData.ProductCollectionAccounts
    .map(getStoreFromProductCollectionAccount)
    .reduce((memo, store) => {
      // eslint-disable-next-line no-param-reassign
      memo[store.id] = store;
      return memo;
    }, {})) || [];
  return stores;
};

export const getCountries = ({ productData, IsDomesticSimplifiedChineseEnabled, legacyI18n }) => {
  const countries = (productData && productData.SalesCountryCollection
    .filter((salesCountry) => {
      const id = salesCountry.Value;
      let result = true;

      if (IsDomesticSimplifiedChineseEnabled) {
        result = result && (id === 'CN');
      }

      return result;
    })
    .map(getCountryFromSalesCountryCollection(legacyI18n))
    .reduce((memo, country) => {
      // eslint-disable-next-line no-param-reassign
      memo[country.id] = country;
      return memo;
    }, {})) || [];
  return countries;
};

